import React, { useState } from 'react';
import './HostingCpanelForeign.css';

const HostingCpanelForeign = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۱۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵ گیگابایت NVMe',
      domains: '۵ دامنه addon',
      email: '۵۰ اکانت ایمیل',
      features: ['SSL رایگان', 'بکاپ هفتگی', 'LiteSpeed Cache', 'لوکیشن هلند/آلمان'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۲۹۰',
      unit: 'هزار تومان / ماه',
      disk: '۲۰ گیگابایت NVMe',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL رایگان', 'بکاپ روزانه', 'LiteSpeed Cache', 'لوکیشن هلند/آلمان', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۵۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵۰ گیگابایت NVMe',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL Wildcard', 'بکاپ روزانه', 'LiteSpeed Cache', 'لوکیشن هلند/آلمان', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🌍',
      title: 'لوکیشن استراتژیک در هلند و آلمان',
      desc: 'سرورهای ما در دیتاسنترهای معتبر هلند و آلمان قرار دارند که بهترین پینگ را برای کاربران اروپایی و جهانی فراهم می‌کنند. این لوکیشن‌ها برای کسب‌وکارهای بین‌المللی ایده‌آل هستند.',
    },
    {
      icon: '⚡',
      title: 'سرورهای NVMe با عملکرد بالا',
      desc: 'استفاده از دیسک‌های NVMe با سرعت خواندن و نوشتن فوق‌العاده بالا برای بارگذاری سریع‌تر وب‌سایت شما و بهبود تجربه کاربری.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته با Imunify360',
      desc: 'محافظت کامل از وب‌سایت شما در برابر حملات سایبری، بدافزارها و هک با سیستم امنیتی پیشرفته Imunify360.',
    },
    {
      icon: '📧',
      title: 'ایمیل سازمانی حرفه‌ای',
      desc: 'ایجاد ایمیل‌های حرفه‌ای با دامنه اختصاصی خودتان و مدیریت کامل از طریق کنترل پنل cPanel با امکانات پیشرفته.',
    },
  ];

  const faqs = [
    {
      q: 'هاست cPanel خارج چه مزایایی نسبت به هاست ایران دارد؟',
      a: 'هاست cPanel خارج روی سرورهای اروپایی قرار دارد و برای وب‌سایت‌های بین‌المللی، کسب‌وکارهای صادراتی و پروژه‌هایی که مخاطب جهانی دارند، بسیار مناسب است. این هاست‌ها محدودیت‌های داخلی را ندارند و با تمام قوانین بین‌المللی سازگار هستند. همچنین برای وب‌سایت‌هایی که نیاز به دیتاسنتر خارج از ایران دارند، انتخاب ایده‌آلی محسوب می‌شوند.',
    },
    {
      q: 'آیا امکان مهاجرت از هاست ایران به هاست خارج وجود دارد؟',
      a: 'بله، تیم پشتیبانی افرسل می‌تواند وب‌سایت شما را به صورت کامل از هاست ایران به هاست خارج منتقل کند. این فرآیند بدون هیچ گونه قطعی در دسترسی به وب‌سایت شما انجام می‌شود و تمام فایل‌ها، پایگاه داده و تنظیمات به صورت کامل منتقل می‌گردند. شما فقط کافی است درخواست خود را ثبت کنید و تیم ما بقیه کارها را انجام می‌دهد.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست cPanel خارج | خرید هاست سی پنل هلند و آلمان | افرسل</h1>
        <p>خرید هاست cPanel خارج با سرورهای NVMe در هلند و آلمان، پشتیبانی ۲۴ ساعته و آپتایم ۹۹.۹٪. هاست سی پنل خارج مناسب برای وب‌سایت‌های بین‌المللی و کسب‌وکارهای صادراتی.</p>
        <meta name="description" content="خرید هاست cPanel خارج با بهترین قیمت از افرسل. هاست سی پنل در هلند و آلمان با سرورهای NVMe، پشتیبانی ۲۴/۷ و آپتایم ۹۹.۹٪." />
      </div>

      <section className="hosting-cpanel-foreign-hero">
        <div className="hosting-cpanel-foreign-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-cpanel-foreign-hero-content">
            <div className="hosting-cpanel-foreign-badge">
              <span className="pulse-dot"></span>
              🌐 هاست cPanel خارج
            </div>
            <h1 className="hosting-cpanel-foreign-hero-title">
              هاست <em>cPanel خارج</em>
            </h1>
            <p className="hosting-cpanel-foreign-hero-desc">
              هاست cPanel خارج با سرورهای NVMe در هلند و آلمان، پشتیبانی ۲۴ ساعته و آپتایم ۹۹.۹٪.
              مناسب برای وب‌سایت‌های بین‌المللی، کسب‌وکارهای صادراتی و پروژه‌های جهانی.
            </p>
            <div className="hosting-cpanel-foreign-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">هلند/آلمان</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-foreign-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست cPanel خارج</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست cPanel خارج با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت بین‌المللی.</p>
          </div>
          <div className="hosting-cpanel-foreign-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-cpanel-foreign-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="hosting-cpanel-foreign-popular-badge">پرفروش‌ترین</span>}
                <div className="hosting-cpanel-foreign-plan-tier">{plan.tier}</div>
                <div className="hosting-cpanel-foreign-plan-price">
                  <span className="hosting-cpanel-foreign-plan-num">{plan.price}</span>
                  <span className="hosting-cpanel-foreign-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-cpanel-foreign-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>🌐</span> {plan.domains}</div>
                  <div><span>📧</span> {plan.email}</div>
                </div>
                <ul className="hosting-cpanel-foreign-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-cpanel-foreign-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-foreign-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست cPanel خارج</span>
            <h2 className="sec-h">چرا <em>هاست cPanel خارج</em> با افرسل؟</h2>
            <p className="sec-p">هاست cPanel خارج با بهترین امکانات و خدمات برای کسب‌وکارهای بین‌المللی.</p>
          </div>
          <div className="hosting-cpanel-foreign-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-cpanel-foreign-feature-card">
                <span className="hosting-cpanel-foreign-feature-icon">{feature.icon}</span>
                <h3 className="hosting-cpanel-foreign-feature-title">{feature.title}</h3>
                <p className="hosting-cpanel-foreign-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-foreign-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-cpanel-foreign-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-cpanel-foreign-faq-item">
                <div className="hosting-cpanel-foreign-faq-q">{faq.q}</div>
                <div className="hosting-cpanel-foreign-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-cpanel-foreign-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>cPanel خارج</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست cPanel خارج، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید هاست</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingCpanelForeign;
